<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Nombre"
          label-for="Nombre"
          :labelCols="labelCols">
          <b-form-input 
            id="nombre"
            v-model.trim="$v.nombre.$model"
            :state="nombreValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="nombreFeedback">
            {{ nombreInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'Nombre',
  props: {
    nombreParam: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      nombre: '',

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 2,
    }
  },
  created() {
    this.nombre = this.nombreParam;
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El texto solo puede contener hasta 50 caracteres';
            // this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta ' + this.maxLength.toString().trim() + ' caracteres';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
          nombre: this.nombre,
        }
        this.$emit('save', params)
      }
    },
    cancelar() {
      this.$emit('cancelar')
    },
  },
  validations: {
    nombre: {
      maxLength: maxLength(50)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
